var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashcanIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.527.622l-.241.503H1.07C.48 1.125 0 1.628 0 2.25s.479 1.125 1.071 1.125H13.93C14.52 3.375 15 2.872 15 2.25s-.479-1.125-1.071-1.125h-3.215l-.24-.503A1.063 1.063 0 009.515 0H5.484c-.405 0-.776.24-.957.622zM13.929 4.5H1.07l.71 11.918c.054.89.757 1.582 1.604 1.582h8.23c.847 0 1.55-.693 1.604-1.582l.71-11.918z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanIcon);
export default ForwardRef;